import React, { useEffect, useState } from "react";
import {
  collection,
  doc,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { Link } from "react-router-dom";

import {
  JoinedUser,
  PostLike,
  FollowedMe,
  ShoppingListChatMessage,
  FirstTimeListView,
  ListProductLike,
  FriendRequest,
  AcceptFriendRequest,
  InviteAccepted,
  ShoppingListInvite,
} from "./NotificationTypes";
import { GroupedNotification } from "./GroupNotification";
import useNotificationStore from "../StatesStore/Notifications";
import ProductPriceChange from "./ProductPriceChange";
import BrandHandlerInvite from "./BrandHandlerInvite";
import PostComment from "./PostComment";
import LoadingSpinner from "../UserProfile/LoadingSpinner";

const notificationComponents = {
  joined: JoinedUser,
  inviteAccepted: InviteAccepted,
  postLike: PostLike,
  postComment: PostComment,
  followed: FollowedMe,
  listChat: ShoppingListChatMessage,
  firstTimeListView: FirstTimeListView,
  listProductLike: ListProductLike,
  inviteOnList: ShoppingListInvite,
  friendRequest: FriendRequest,
  brandHandlerInvite: BrandHandlerInvite,
  acceptFriendRequest: AcceptFriendRequest,
  productPriceChange: ProductPriceChange,
};

function Notification({ user, userData, newNotificationsCount }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const addNotifications = useNotificationStore(
    (state) => state.addNotifications
  );

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    const notificationsRef = collection(db, `users/${user.uid}/notifications`);
    const q = query(notificationsRef, orderBy("timestamp", "desc"), limit(6));

    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const notificationData = querySnapshot.docs.map((docSnapshot) => ({
          notificationId: docSnapshot.id,
          ...docSnapshot.data(),
        }));
        setNotifications(notificationData);
        addNotifications(notificationData);
      },
      (error) => {
        console.error("Error fetching notifications in real-time: ", error);
      }
    );
    setLoading(false);
    return () => unsubscribe();
  }, [user]);

  // const handleNotificationClick = async () => {
  //   if (newNotificationsCount > 0) {
  //     const userDocRef = doc(db, "users", user.uid);
  //     await updateDoc(userDocRef, {
  //       lastSeenNotification: serverTimestamp(), // Update with the server timestamp
  //     });
  //     // setLastSeenNotification(new Date()); // Update in local state as well
  //     setTimeout(() => {
  //       // setNewNotificationsCount(0); // Reset the new notifications count
  //     }, 2000);
  //   }
  // };

  const renderNotification = (notification) => {
    if (Array.isArray(notification.id) && notification.id.length > 1) {
      return (
        <GroupedNotification
          key={notification.notificationId}
          notification={notification}
          groupedNotifications={notification}
          user={user}
        />
      );
    }

    const NotificationComponent = notificationComponents[notification.type];
    if (!NotificationComponent) return null;
    return (
      <NotificationComponent
        key={notification.notificationId}
        notification={notification}
        user={user}
      />
    );
  };

  return (
    <>
      <div
        className={`card-header p-0 px-3 d-flex justify-content-between align-items-center border-bottom ${notifications.length > 0 ? "" : "rounded-3 rounded-bottom-0"
          }`}
      >
        <div className="d-flex align-items-center">
          <span
            className="mb-2"
            style={{
              fontFamily: "Inter",
              color: "#000000",
              fontWeight: 600,
              fontSize: "1rem",
            }}
          >
            Notifications
          </span>
          {/* <span
            className="badge rounded-circle ms-2 d-flex justify-content-center align-items-center mb-2"
            style={{
              width: "22px",
              height: "22px",
              fontSize: "14px",
              backgroundColor: "#0085FF",
            }}
          >
            {newNotificationsCount}
          </span> */}
        </div>
       
          <Link className="small mb-2" to="/notifications">
            View all
          </Link>
       
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : notifications && notifications.length > 0 ? (
        <div className="card-body p-0 m-0">
          <div
            className="p-0"
            style={{
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
              overflow: "hidden",
              whiteSpace: "collapse",
            }}
          >
            {notifications.slice(0, 5).map((notification, index) => (
              <>{renderNotification(notification)}</>
            ))}
          </div>
        </div>
      ) : (
        <div
          style={{
            whiteSpace: "normal",
            width: "100%",
            fontFamily: "Inter",
            fontWeight: 500,
            color: `rgb(0, 0, 0, 0.5)`,
            fontSize: "20px",
            lineHeight: "1.5rem",
            letterSpacing: "0px",
            minHeight: "250px",
          }}
          className="text-center m-0 p-4 h-100 d-flex align-items-center justify-content-center"
        >
          No notifications yet...
        </div>
      )}
      {/* <div className="card-footer text-center">
								<a href="#" className="btn btn-sm btn-primary-soft">See all incoming activity</a>
							</div> */}
    </>
  );
}

export default Notification;
